import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-250fa0c6")

_pushScopeId("data-v-250fa0c6")
const _hoisted_1 = {
  key: 0,
  class: "flex items-center w-full max-w-2xl mx-auto h-full"
}
const _hoisted_2 = { class: "text-base leading-normal font-medium mb-8 sm:mb-12 sm:text-xl sm:leading-relaxed" }
const _hoisted_3 = { class: "inline-flex align-middle items-center rounded-md font-medium text-xs px-3 py-1.5 border border-primary-500 text-primary-500 mr-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "全生徒エクスポート", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" から")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("し、必要部分を変更した後に取り込んでください。 ")
const _hoisted_7 = { class: "text-xs leading-normal text-gray-500 mb-8 sm:mb-12 sm:text-base sm:leading-relaxed" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ※ 一部生徒のCSV出力は ")
const _hoisted_9 = { class: "inline-flex align-middle items-center rounded-md font-medium text-xs px-3 py-1.5 mx-2 text-white bg-primary-500" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "選択中の生徒に実行", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" の「生徒データを出力」から可能です。 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-base font-medium sm:text-xl" }, [
  /*#__PURE__*/_createTextVNode(" 詳細は"),
  /*#__PURE__*/_createVNode("a", {
    href: "https://mingaku.notion.site/4d4ef296e77482f289850103fd0f0482",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "text-sky underline cursor-pointer"
  }, "ガイド"),
  /*#__PURE__*/_createTextVNode("をご覧ください。 ")
], -1)
const _hoisted_13 = { class: "mt-8 flex items-start gap-3 bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-semibold text-amber-800 mb-2" }, " CSV編集前にご確認ください "),
  /*#__PURE__*/_createVNode("p", { class: "text-amber-700 leading-relaxed" }, " ※ダウンロードしたCSVは、Excelで開くと一部データが自動変換される場合があります。 "),
  /*#__PURE__*/_createVNode("p", { class: "text-amber-700 leading-relaxed" }, [
    /*#__PURE__*/_createTextVNode(" 編集前に"),
    /*#__PURE__*/_createVNode("a", {
      class: "font-semibold underline text-sky",
      href: "https://mingaku.notion.site/edeef296e774831682180108e7e229c5",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "CSVダウンロード時のデータ化け対策ガイド"),
    /*#__PURE__*/_createTextVNode("をご確認ください。 ")
  ])
], -1)
const _hoisted_15 = {
  key: 1,
  class: "text-2xl flex flex-col gap-4"
}
const _hoisted_16 = { class: "text-xl" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" こちらの")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("して、必要事項を入力の上取り込んでください。 ")
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "text-xl" }, [
  /*#__PURE__*/_createTextVNode(" 取り込み方法は"),
  /*#__PURE__*/_createVNode("a", {
    class: "font-bold underline text-sky",
    href: "https://mingaku.notion.site/d49ef296e77483b4a1f781ba2d819f16",
    target: "_blank"
  }, "マニュアル"),
  /*#__PURE__*/_createTextVNode(" を参考にしてください。 ")
], -1)
const _hoisted_20 = { class: "flex items-start gap-3 bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-semibold text-amber-800 mb-2" }, " CSV編集前にご確認ください "),
  /*#__PURE__*/_createVNode("p", { class: "text-amber-700 leading-relaxed" }, " ※ダウンロードしたCSVは、Excelで開くと一部データが自動変換される場合があります。 "),
  /*#__PURE__*/_createVNode("p", { class: "text-amber-700 leading-relaxed" }, [
    /*#__PURE__*/_createTextVNode(" 編集前に"),
    /*#__PURE__*/_createVNode("a", {
      class: "font-semibold underline text-sky",
      href: "https://mingaku.notion.site/edeef296e774831682180108e7e229c5",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "CSVダウンロード時のデータ化け対策ガイド"),
    /*#__PURE__*/_createTextVNode("をご確認ください。 ")
  ])
], -1)
const _hoisted_22 = {
  key: 2,
  class: "text-2xl flex flex-col gap-4"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" こちらの")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("して、必要事項を入力の上取り込んでください。 ")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 取り込み方法は"),
  /*#__PURE__*/_createVNode("span", { class: "font-bold text-sky" }, "マニュアル（準備中）"),
  /*#__PURE__*/_createTextVNode("を参考にしてください。 ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "text-base font-semibold text-red-500" }, " ※ ダウンロードしたファイル名は変更しないでください。 ", -1)
const _hoisted_27 = {
  key: 3,
  class: "text-2xl flex flex-col gap-4"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" こちらの")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("して、必要事項を入力の上取り込んでください。 ")
const _hoisted_30 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 取り込み方法は"),
  /*#__PURE__*/_createVNode("span", { class: "font-bold text-sky" }, "マニュアル（準備中）"),
  /*#__PURE__*/_createTextVNode("を参考にしてください。 ")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "text-base font-semibold text-red-500" }, " ※ ダウンロードしたファイル名は変更しないでください。 ", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ファイル取り込み ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" ファイル取り込み ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" ファイル取り込み ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" ファイル取り込み ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, {
    size: _ctx.modalSize,
    height: _ctx.modalBodyHeight,
    onClose: _ctx.close
  }, {
    title: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    body: _withId(() => [
      (_ctx.type === 'studentsUpdate')
        ? (_openBlock(), _createBlock("section", _hoisted_1, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "3",
                      class: "mr-1.5"
                    }),
                    _hoisted_4
                  ]),
                  _hoisted_5,
                  _createVNode("span", {
                    class: "text-sky underline cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportStudents && _ctx.exportStudents(...args)))
                  }, "CSVをダウンロード"),
                  _hoisted_6
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", null, [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_m_icon, {
                      type: "chevron-down",
                      width: "3",
                      class: "ml-1.5"
                    })
                  ]),
                  _hoisted_11
                ])
              ]),
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_m_icon, {
                  type: "warning",
                  size: "6",
                  class: "shrink-0 text-yellow-500 mt-0.5"
                }),
                _hoisted_14
              ])
            ])
          ]))
        : (_ctx.type === 'studentsRegister')
          ? (_openBlock(), _createBlock("section", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("span", {
                  class: "font-bold text-sky underline cursor-pointer",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportMultiStudentRegistrationTemplate && _ctx.exportMultiStudentRegistrationTemplate(...args)))
                }, "CSVをダウンロード"),
                _hoisted_18
              ]),
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_m_icon, {
                  type: "warning",
                  size: "6",
                  class: "shrink-0 text-yellow-500 mt-0.5"
                }),
                _hoisted_21
              ])
            ]))
          : (_ctx.type === 'googleLinkage')
            ? (_openBlock(), _createBlock("section", _hoisted_22, [
                _createVNode("div", null, [
                  _hoisted_23,
                  _createVNode("span", {
                    class: "font-bold text-sky underline cursor-pointer",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportGoogleTemplate && _ctx.exportGoogleTemplate(...args)))
                  }, "CSVをダウンロード"),
                  _hoisted_24
                ]),
                _hoisted_25,
                _hoisted_26
              ]))
            : (_openBlock(), _createBlock("section", _hoisted_27, [
                _createVNode("div", null, [
                  _hoisted_28,
                  _createVNode("span", {
                    class: "font-bold text-sky underline cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportMicrosoftTemplate && _ctx.exportMicrosoftTemplate(...args)))
                  }, "CSVをダウンロード"),
                  _hoisted_29
                ]),
                _hoisted_30,
                _hoisted_31
              ]))
    ]),
    footer: _withId(() => [
      (_ctx.type === 'studentsUpdate')
        ? (_openBlock(), _createBlock(_component_m_button, {
            key: 0,
            color: "primary-500",
            "hover-color": "primary-600",
            onClick: _ctx.startUpdating
          }, {
            default: _withId(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_ctx.type === 'studentsRegister')
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 1,
              color: "primary-500",
              "hover-color": "primary-600",
              onClick: _ctx.startMultiStudentRegistration
            }, {
              default: _withId(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_ctx.type === 'googleLinkage')
            ? (_openBlock(), _createBlock(_component_m_button, {
                key: 2,
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.startGoogleUpdating
              }, {
                default: _withId(() => [
                  _hoisted_34
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_m_button, {
                key: 3,
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.startMicrosoftUpdating
              }, {
                default: _withId(() => [
                  _hoisted_35
                ]),
                _: 1
              }, 8, ["onClick"]))
    ]),
    _: 1
  }, 8, ["size", "height", "onClose"]))
})